// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const BUILDINFO = {
  "hash": "6576b444ecfc08905d68e6524e490e3b51c9c8c1",
  "tag": "",
  "github": {
    "runId": "",
    "runNumber": "",
    "runAttempt": ""
  }
};
/* tslint:enable */
